import { EVENT_KEY, TRACKING_INTERACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const aiTracking = {
  trackAi () {
    const interaction = {
      openAiChat: () => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_CHAT }),
      aiWritingTool: () => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_WRITING_TOOL }),
      newsTextFeedback: () => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_NEWS_TEXT_FEEDBACK}),
      newsTextFeedbackFinished: (feedbackAmount, result) => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_NEWS_TEXT_FEEDBACK_FINISHED, feedback_count: feedbackAmount, result }),
      newsGenerate: () => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_NEWS_GENERATE }),
      newsGenerateAccepted: () => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_NEWS_GENERATE_ACCEPTED }),
      newsGenerationHintOpen: () => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_NEWS_GENERATION_HINT_OPEN }),
      newsGenerationHintClose: () => trackingUtils.track(EVENT_KEY.AI.INTERACTION, { feature: 'news', interaction: TRACKING_INTERACTION.CLICK_AI_NEWS_GENERATION_HINT_CLOSE }),
    }

    return { interaction }
  }
}

export default aiTracking
